import React, { Suspense, useEffect } from 'react'
import { usePath, useRoutes } from 'hookrouter'
import { rootRoutes } from './routes'
import { useFetchBreakpoint } from '../store/navigation/hooks/useFetchBreakpoint'
import 'swiper/swiper-bundle.min.css'
import { useTracking } from 'hooks/useTracking'

export const App = () => {
  const path = usePath()
  const { trackPageview } = useTracking()
  useFetchBreakpoint()

  useEffect(() => {
    window.scrollTo(0, 0)
    trackPageview()
  }, [path])

  return <Suspense fallback={<div></div>}>{useRoutes(rootRoutes)}</Suspense>
}
